import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Activity } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, afterAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // useRef guard (not state) — prevents a double exchange under StrictMode.
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data.user);
        await afterAuth();
        toast.success(`Welcome${data.user?.name ? `, ${data.user.name.split(" ")[0]}` : ""}!`);
        navigate("/history", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error(e);
        toast.error("Sign-in could not be completed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen bg-[#05050A] text-white flex flex-col items-center justify-center gap-4"
    >
      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#0B3D91] to-cyan-500 flex items-center justify-center animate-pulse shadow-[0_0_25px_rgba(0,229,255,0.4)]">
        <Activity className="w-6 h-6 text-white" />
      </div>
      <div className="text-sm text-zinc-400">Signing you in…</div>
    </div>
  );
}
